const isEmpty = value => value === '' || value === null || value === undefined;

const appendLotImages = (formData, images) => {
  let formDataIndex = 0;

  images.forEach(({ image, index }) => {
    if (!image.originFileObj) return;

    formData.append(`lotImagesToAdd[${formDataIndex}].Image`, image.originFileObj);
    formData.append(`lotImagesToAdd[${formDataIndex}].Index`, index);
    formDataIndex += 1;
  });
};

const appendArrayField = (formData, key, values) => {
  if (!values?.length) return;

  values.forEach(item => {
    formData.append(key, key === 'tagIds' ? item.id ?? item : item);
  });
};

export const prepareRequest = (values, isDraft) => {
  const valuesToSubmit = {
    ...values,
    lotImagesToAdd: values.lotImagesToAdd.map((img, index) => ({
      image: { ...img },
      index,
    })),
    categoryId: values.subcategoryId,
  };

  delete valuesToSubmit.subcategoryId;

  const formData = new FormData();

  Object.entries(valuesToSubmit).forEach(([key, value]) => {
    if (isDraft && isEmpty(value)) return;

    if (Array.isArray(value)) {
      if (key === 'lotImagesToAdd') {
        appendLotImages(formData, value);
      } else {
        appendArrayField(formData, key, value);
      }

      return;
    }

    if (!isEmpty(value)) {
      formData.append(key, value);
    }
  });

  formData.append('isDraft', isDraft);

  return formData;
};